export default "__VITE_ASSET__Bjn2vI9F__"